import slick from 'slick-carousel';
import debounce from 'lodash/debounce';

const $pageHeader = $('.page-header');
const $plusSlider = $pageHeader.find('.page-header__pluses ul');

let plusSlick = null;

const setupPlusSlider = () => {
    if (!$plusSlider.length) {
        return;
    }

    if (window.matchMedia('(max-width: 639px)').matches) {
        if (!plusSlick) {
            plusSlick = $plusSlider.slick({
                fade: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 2000,
            });
        }
    } else {
        if (plusSlick) {
            plusSlick.slick('unslick');
            plusSlick = null;
        }
    }
};

$(window).on('resize', debounce(setupPlusSlider, 250));

export default {
    can: () => $pageHeader.length,
    run: () => {
        setupPlusSlider();
    },
};
